export default __webpack_public_path__ + "static/media/gcp-repos.2fcf5f48.svg";